import en from './en.json';
import pt from './pt.json';
import he from './he.json';
import es from './es.json';

export const languages = {
  en: en,
  pt: pt,
  he: he,
  es: es,
};
